export default __webpack_public_path__ + "static/media/peter_choong.419ba5ca.jpg";